import React from 'react'

export const TransferirTitular = () => {

    const REACT_APP_URL_TRANSFERIR_TITULAR = process.env.REACT_APP_URL_TRANSFERIR_TITULAR;

    window.location.replace(REACT_APP_URL_TRANSFERIR_TITULAR);

    return <></>
}